// extracted by mini-css-extract-plugin
export default {"Backdrop":"Modal_Backdrop__hylVv","Modal":"Modal_Modal__cTPBx"};